<app-tab>
  <dx-data-grid
    id="tractorsGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{ stateStorageKey: 'app-tractors-grid' }"
    [libGridTitle]="{ text: 'Tracteurs' }"
    (onEditingStart)="onEditingStart($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserted)="loadTrackers()"
    (onRowUpdated)="loadTrackers()"
    (onRowRemoved)="loadTrackers()"
    (onRowUpdating)="onRowUpdating($event)"
    (onRowInserting)="onRowInserting($event)"
  >
    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataType="number"
    >
    </dxi-column>

    <dxi-column caption="Code" dataType="string" dataField="code">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="async"
        message="Code existe déjà"
        [validationCallback]="codeValidation"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      *ngIf="
        systemColumns.length > 0 &&
        (canListThirdPartSystems || canEditThirdPartSystems)
      "
      caption="Systèmes extérieurs"
      [columns]="systemColumns"
    >
    </dxi-column>

    <dxi-column caption="Nom" dataField="name">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="150"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="Matricule" dataField="licence_plate">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="45"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="Puissance" dataType="number" dataField="engine_power">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Catégorie Puissance"
      dataType="string"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="engine_power_category"
    >
    </dxi-column>

    <dxi-column
      caption="Traceur"
      dataType="string"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      [customizeText]="displayImei"
      dataField="tracker.imei"
    >
    </dxi-column>

    <dxi-column caption="Marque" dataField="brand">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="150"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column caption="Modèle" dataField="model">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="stringLength"
        [min]="3"
        [max]="150"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Date d'acquisition"
      dataField="acquisition_date"
      cellTemplate="acquisitionDateTemplate"
      format="shortDate"
      dataType="date"
    >
      <dxo-form-item
        editorType="dxDateBox"
        [editorOptions]="{ type: 'date' }"
      ></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <div *dxTemplate="let cell of 'acquisitionDateTemplate'">
        {{ !cell.data.is_subcontract ? cell.text : "NA" }}
      </div>
    </dxi-column>

    <dxi-column
      caption="Age"
      dataType="string"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="age"
    >
    </dxi-column>

    <dxi-column
      caption="État"
      dataType="string"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="age_status"
    >
    </dxi-column>

    <dxi-column
      caption="Valeur d'acquisition"
      dataField="acquisition_value"
      format="#,##0.## DHs"
      cellTemplate="acquisitionValueTemplate"
      dataType="number"
    >
      <dxo-form-item
        editorType="dxNumberBox"
        [editorOptions]="{ format: '#,##0.## DHs' }"
      ></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <div *dxTemplate="let cell of 'acquisitionValueTemplate'">
        {{ !cell.data.is_subcontract ? cell.text : "NA" }}
      </div>
    </dxi-column>

    <dxi-column
      caption="Année de production"
      dataType="number"
      dataField="production_year"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Mode d'aquisition"
      [showEditorAlways]="false"
      falseText="Locale"
      trueText="Sous-traité"
      dataType="boolean"
      editCellTemplate="subcontractEditor"
      dataField="is_subcontract"
    >
      <div *dxTemplate="let cellInfo of 'subcontractEditor'">
        <div style="height: 35px" class="flex felx items-center h-full">
          <dx-switch
            [value]="cellInfo.value"
            (onValueChanged)="subContractChange($event, cellInfo)"
          ></dx-switch>
        </div>
      </div>
    </dxi-column>

    <dxi-column
      caption="Domaine"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="domain_name"
    >
    </dxi-column>

    <dxi-column
      caption="BU"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="business_unit_name"
    >
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false"
    >
      <div *dxTemplate="let cellInfo of 'domainChooser'">
        <app-user-domains-chooser
          (valueChange)="cellInfo.setValue($event)"
          [id]="cellInfo.value"
        ></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="tracker_id"
      caption="Traceur"
      [visible]="false"
      [formItem]="{ visible: canAssignTracker || !isNew }"
      editCellTemplate="trackerChooser"
      [showInColumnChooser]="false"
    >
      <div *dxTemplate="let cellInfo of 'trackerChooser'">
        <lib-tracker-chooser
          [canAssign]="canAssignTracker"
          (valueChange)="cellInfo.setValue($event)"
          [tracker]="cellInfo.data.tracker"
          [trackerId]="cellInfo.value"
          (reload)="loadTrackers()"
          [availableTrackers]="availableTrackers"
        >
        </lib-tracker-chooser>
      </div>
    </dxi-column>

    <dxi-column
      caption="formule de carburant"
      dataField="settings.fuel_formula"
      [allowFiltering]="false"
    >
      <dxi-validation-rule
        type="pattern"
        pattern="^[0-9\+\-\*\/]+$"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Min POI"
      dataType="number"
      dataField="settings.minimum_poi"
      [allowSearch]="false"
    >
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit"
    >
      <dxo-popup [onShowing]="editPopup" width="50%"></dxo-popup>
      <dxo-form
        [colCount]="1"
        [showValidationSummary]="true"
        labelLocation="top"
      >
        <dxi-item itemType="group" colCount="2" caption="Général">
          <dxi-item dataField="code"></dxi-item>
          <dxi-item dataField="name"></dxi-item>
          <dxi-item dataField="engine_power"></dxi-item>
          <dxi-item dataField="licence_plate"></dxi-item>
          <dxi-item dataField="brand"></dxi-item>
          <dxi-item dataField="model"></dxi-item>
          <dxi-item dataField="production_year"></dxi-item>
          <dxi-item dataField="domain_id"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Parametres">
          <dxi-item
            dataField="settings.minimum_poi"
            [editorOptions]="{
              value: 0,
              showSpinButtons: true,
              mode: 'number',
              format: '#0',
              min: 0,
              max: 20,
              hint:
                'Définir le nombre de visites POI (de 0 à 20) pour démarrer une interventionde transport'
            }"
          ></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colCount="2" caption="Paramètres de Reconstruction">
          <dxi-item
            dataField="reconstruction_min_work_duration_minutes"
            [label]="{ text: 'Durée min. travail (min)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#0',
              min: 0,
              step: 1,
              placeholder: 'Auto (15-20 min)',
              hint: 'Durée minimale de travail. Vide = calculé selon puissance (15-20 min)'
            }"
          ></dxi-item>
          <dxi-item
            dataField="reconstruction_max_off_duration_minutes"
            [label]="{ text: 'Durée max. arrêt (min)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#0',
              min: 0,
              step: 1,
              placeholder: '10',
              hint: 'Durée maximale d\'arrêt ACC avant rupture. Vide = défaut 10 min'
            }"
          ></dxi-item>
          <dxi-item
            dataField="reconstruction_max_idle_duration_minutes"
            [label]="{ text: 'Durée max. inactif (min)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#0',
              min: 0,
              step: 1,
              placeholder: '30',
              hint: 'Durée maximale d\'inactivité avant rupture. Vide = défaut 30 min'
            }"
          ></dxi-item>
          <dxi-item
            dataField="reconstruction_min_intervention_area_m2"
            [label]="{ text: 'Surface min. intervention (m²)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#,##0.##',
              min: 0,
              step: 10,
              placeholder: 'Auto (500-750 m²)',
              hint: 'Surface minimale d\'intervention. Vide = calculé selon puissance et largeur (500-750+ m²)'
            }"
          ></dxi-item>
          <dxi-item
            dataField="reconstruction_min_path_length_meters"
            [label]="{ text: 'Longueur min. trajet (m)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#,##0.##',
              min: 0,
              step: 1,
              placeholder: 'Auto (50-75 m)',
              hint: 'Longueur minimale du trajet. Vide = calculé selon puissance et largeur (50-75+ m)'
            }"
          ></dxi-item>
          <dxi-item
            dataField="reconstruction_min_working_speed_percent"
            [label]="{ text: 'Pourcentage min. vitesse (%)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#0.##',
              min: 0,
              max: 100,
              step: 0.01,
              placeholder: '30',
              hint: 'Pourcentage minimal de temps avec vitesse de travail. Vide = défaut 30%'
            }"
          ></dxi-item>
          <dxi-item
            dataField="reconstruction_min_field_coverage_percent"
            [label]="{ text: 'Couverture min. parcelle (%)' }"
            [editorOptions]="{
              showSpinButtons: true,
              mode: 'number',
              format: '#0.##',
              min: 0,
              max: 100,
              step: 0.01,
              placeholder: '40',
              hint: 'Pourcentage minimal de points dans la parcelle. Vide = défaut 40%'
            }"
          ></dxi-item>
        </dxi-item>

        <dxi-item
          *ngIf="canEditThirdPartSystems"
          itemType="group"
          colCount="2"
          [items]="systemColumns"
          caption="Systèmes extérieurs"
        >
        </dxi-item>

        <dxi-item itemType="group" caption="Tracking">
          <dxi-item dataField="tracker_id"></dxi-item>
          <dxi-item dataField="settings.fuel_formula"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colCount="3" caption="Acquisition">
          <dxi-item
            *ngIf="!isSubContract"
            dataField="acquisition_date"
          ></dxi-item>
          <dxi-item
            *ngIf="!isSubContract"
            dataField="acquisition_value"
          ></dxi-item>
          <dxi-item
            [label]="{ text: 'Sous-Traité?' }"
            dataField="is_subcontract"
          ></dxi-item>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-export
      [enabled]="true"
      fileName="liste-tracteurs"
      [allowExportSelectedData]="true"
    ></dxo-export>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true"
    >
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
  </dx-data-grid>
</app-tab>
